<template>
  <div>
    <background>
      <template #g>
        <foreignObject v-for="(animation, index) in animations"
                       :key="'svg_'+index"
                       v-bind="animation.svg">
          <!-- mouseover/mousleave have been commented out, because the animations overlap.
          In those circumstances we cannot determine which animation has been hovered. The effect is that
          sometimes the wrong tooltip would be displayed...!
            @mouseover.native="() => {hoverIndex = index}"
            @mouseleave.native="hoverIndex = -1"
          -->
          <fin-lottie-switch
            :animate="selectedIndex === index || hoverIndex === index"
            :options="{animationData: animation.animationData, autoplay: false}"
          />
        </foreignObject>
      </template>

      <template>
        <!--
            - adding .prevent to @mouseover.native fixed the problem, that the dot was not selected
                  straight away on iPad
            - @click und @mousedown are both needed, because Mac do not get the click events
            - events on iPad
                  1st touch =>  mouseover.native.prevent + mousedown.native
                  2nd touch =>  mouseover.native.prevent + mousedown.native + click.native
                  3rd touch =>  mousedown.native + click.native


            - .capture after @click.native is most probably not needed - TOCHECK
            - not sure, whether @touchstart is needed or not...  - TOCHECK
        -->
        <fin-step-by-step-button :active="value === index"
                                 :hovered="hoverIndex === index"
                                 :key="'btn_'+index"
                                 :tooltipText="tooltipTexts[index].tooltip.text"
                                 :class="'btn_'+index"
                                 :style="animation.buttonStyle"
                                 @click.native.capture.stop.prevent="() => {buttonClicked(index)}"
                                 @mousedown.native.stop="() => {buttonClicked(index)}"
                                 @touchstart="() => {buttonClicked(index)}"
                                 @touchstart.native.capture.stop="() => {buttonClicked(index)}"
                                 @mouseover.native.prevent.stop="() => {hoverIndex = index}"
                                 @mouseleave.native.stop="() => {hoverIndex = -1}"
                                 v-for="(animation, index) in animations"
        />
        <span :key="'text_'+index"
              :style="animation.textStyle"
              v-for=" (animation, index) in animations">
          {{ animation.title }}
        </span>

      </template>
    </background>
  </div>
</template>

<script>
import FinStepByStepButton from '@/components/pages/onboarding/Step2/StepByStep/StepByStepBtn/index'
import Background from './Background'
import FinLottieSwitch from '@/components/pages/onboarding/Step2/StepByStep/LottieSwitch/index'

export default {
  name: 'finStepByStep1Illu',
  components: { FinLottieSwitch, FinStepByStepButton, Background },
  props: {
    value: {
        type: Number
    },
      animations: {
          type: Array
      },
      tooltipTexts: {
          type: Array
      }
  },
  data () {
    return {
      hoverIndex: -1,
      selectedIndex: -1
    }
  },
  methods: {
    buttonClicked(index) {
      this.$emit('input', index)
      this.selectedIndex = index
    }
  }
}
</script>

<style scoped>

</style>
